import React, { FC, MouseEventHandler, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import styles from './index.module.scss';
import SeeMoreIconButton from 'components/atoms/SeeMoreIconButton';

interface Props {
  defaultExpanded?: boolean;
  minHeight: number;
  title?: string;
  expandText?: string;
  testId?: string;
  hasIcon?: boolean;
  className?: string;
  expandClassname?: string;
}

const Expandable: FC<Props> = (
  {
    minHeight,
    title,
    expandText,
    defaultExpanded = true,
    testId = '',
    hasIcon = true,
    className = '',
    expandClassname,
    children,
  }
) => {
  const { t } = useTranslation('marketingPages');
  const buttonText = expandText || t('showAll')

  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleExpand = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setExpanded(!expanded);
    },
    [expanded]
  );

  return (
    <div className={classNames(styles.container, className)}>
      {title && <p>{title}</p>}
      <AnimateHeight duration={300} height={expanded ? 'auto' : minHeight}>
        {children}
      </AnimateHeight>
      {!expanded && (
        <SeeMoreIconButton className={expandClassname} text={buttonText} onClick={handleExpand} testId={testId} hasIcon={hasIcon} />
      )}
    </div>
  );
};

export default Expandable;
export type { Props as ExpandableProps };
